/**
 * 枚举类型定义
 */

// 审核状态枚举项
export interface iReviewStatusEnum {
  label: string;
  value: number;
}

// 批量任务功能类型枚举项
export interface iBatchTaskFuncTypeEnum {
  label: string;
  value: string;
}

// 批量任务状态枚举项
export interface iBatchTaskStatusEnum {
  label: string;
  value: number;
}

// actions type
export const SET_REVIEW_STATUS_ENUM = 'SET_REVIEW_STATUS_ENUM';
export const SET_BATCH_TASK_FUNC_TYPES = 'SET_BATCH_TASK_FUNC_TYPES';
export const SET_BATCH_TASK_STATUSES = 'SET_BATCH_TASK_STATUSES';
